// extracted by mini-css-extract-plugin
export default {"root":"SimpleTableCell_root__OmDXg","head":"SimpleTableCell_head__pEyLU"};